<template lang="pug">
  .circle(
    :active="active"
    :style="circleStyle"
  )
    v-icon(v-if="done" color="#fff") mdi-check
    p(v-else) {{ number }}
</template>

<script>
  export default {
    name: 'NumberCircle',
    props: {
      done: {
        type: Boolean,
        default: false,
      },
      number: {
        type: Number,
        default: 0,
      },
      active: {
        type: Boolean,
        defatult: 0,
      },
    },
    computed: {
      circleStyle () {
        const { done, active } = this
        const styles = {
          color: '#111',
        }
        if (done) {
          styles.backgroundColor = 'green'
          styles.color = 'white'
        } else if (active) {
          styles.backgroundColor = 'white'
        } else {
          styles.backgroundColor = '#fff9'
        }
        return styles
      },
    },
  }
</script>

<style lang="scss" scoped>
  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 25px;
    margin: 5px;
    &[active] {
      box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    }
  }
  p {
    font-weight: 400;
    color: inherit;
    margin: 0;
    font-size: 1.5rem;
  }
</style>
